<div class="center">
    <iui-messages class="ms-auto me-auto" mode="alert"></iui-messages>
</div>

<div style="margin-bottom: 10em;" *ngIf="!successfullySubmitted">

  <div *ngIf="false" style="border: 1px solid red; color: red; width: 100%;">
      {{accountRegistration|json}}
  </div>

  <form #f="ngForm" (ngSubmit)="save(f.valid)">
    <div class="container-fluid">
      <div class="ui-g">
        <div class="ui-g-12">
          <p class="heading">
            Register for an iconectiv® TruNumber Finder Account
          </p>
          <p class="sub-heading">
            To register for a new iconectiv® TruNumber Finder account, please complete the following fields. 
            Shortly after submission, the Customer Support team will contact you via email with information to 
            complete account setup with billing information, pricing tier selection and acceptance of terms.
          </p>
          <p>
            <strong>If your company already has a TruNumber Finder account, and you wish to be added as a new user, 
              please contact your account administrator. </strong>
          </p>
        </div>
      </div>
       <!-- Registrant Contact Information ----------------------------------- -->
       <div class="ui-g">
        <div class="ui-g-12">
          <span class="sub-heading-strong">Registrant Contact Information</span>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-3">

          <div class="mb-3">
              <label class="required form-label" for="firstName">First Name</label>
              <input type="text" class="form-control" id="firstName"
                required
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.firstName" name="firstName"
                #firstName="ngModel">
          </div>

          <div class="mb-3">
              <label class="required form-label" for="lastName">Last Name</label>
              <input type="text" class="form-control" id="lastName"
                required
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.lastName" name="lastName"
                #lastName="ngModel">
          </div>

          <div class="mb-3">
              <label class="required form-label" for="companyName">Company Name</label>
              <input type="text" class="form-control" id="companyName"
                required
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.companyName" name="companyName"
                #companyName="ngModel">
          </div>

        </div>
        <div class="ui-g-3">

          <div class="mb-3">
              <label class="required form-label" for="email">Email</label>
              <input type="text" class="form-control" id="email"
                required
                emailvalidator
                [(ngModel)]="accountRegistration.email" name="email"
                placeholder="email@domain.com"
                #email="ngModel">
          </div>

          <div class="mb-3">
              <label class="form-label" for="phone">Telephone Number</label>
              <input type="text" class="form-control" id="phone"
                pattern="(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}"
                [(ngModel)]="accountRegistration.phone" name="phone"
                #phone="ngModel">
          </div>

          <div class="mb-3">
              <label class="form-label" for="country">Country</label>
              <div class="input-group">
                <p-dropdown
                  [(ngModel)]="accountRegistration.country"
                  
                  [region]='state'
                  [style]="{'width': '100%'}"
                  #country
                  class="p-formcontrol"
                  filter="true"
                  id="country"
                  iuiCountry
                  name="country"
                  placeholder="Select"
                ></p-dropdown>
            </div>
          </div>

        </div>
        <div class="ui-g-3">

          <div class="mb-3">
              <label class="form-label" for="address1">Address 1</label>
              <input type="text" class="form-control" id="address1"
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.address1" name="address1"
                placeholder="street address"
                #address1="ngModel">
          </div>

          <div class="mb-3">
              <label class="form-label" for="address2">Address 2</label>
              <input type="text" class="form-control" id="address2"
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.address2" name="address2"
                placeholder="suite, floor, etc"
                #address2="ngModel">
          </div>

          <div class="mb-3">
              <label class="form-label" for="zipCode">City</label>
              <input type="text" class="form-control" id="city"
                [pattern]="nameValidatorPattern()"
                [(ngModel)]="accountRegistration.city" name="city"
                #city="ngModel">
          </div>

        </div>
        <div class="ui-g-3">

          <div class="mb-3">
            <label class="form-label" for="state">State/Province</label>
            <div class="input-group">
              <p-dropdown
                [(ngModel)]="accountRegistration.state"
                
                [style]="{'width': '100%'}"
                [disabled]=!accountRegistration.country
                #state
                class="p-formcontrol"
                filter="true"
                id="state"
                iuiRegion
                name="state"
                placeholder="Select"
              ></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
              <label class="form-label" for="zipCode">Postal/ ZIP Code</label>
              <input type="text" class="form-control" id="zipCode"
                [pattern]="zipCodeValidatorPattern(accountRegistration.country)"
                [(ngModel)]="accountRegistration.zipCode" name="zipCode"
                #zipCode="ngModel">
          </div>

        </div>
      </div>

      
      <!-- Regional User Agreement ------------------------------------------ -->
      <!--div class="ui-g">
        <div class="ui-g-12">
          <span class="sub-heading-strong">Regional User Agreement </span>
        </div>
      </div-->

      <!-- Regional User Agreement Heading ---------------------------------- -->
      <!--div style="border-top: 2px solid gray; border-bottom: 2px solid gray;">
      <div class="ui-g ui-fluid">
        <div class="ui-g-3">
          <div>Region</div>
          <div></div>
        </div>
        <div class="ui-g-3">
          <div>Contract Number</div>
          <div></div>
        </div>
        <div class="ui-g-3">
          <div>Effective Date</div>
          <div></div>
        </div>
        <div class="ui-g-3">
          <div>Attachment</div>
          <div>(.pdf file of Regional User Agreement)</div>
        </div>
      </div>

      <!-- Regional User Agreement Details ---------------------------------- 
      <div class="ui-g ui-fluid" *ngFor="let region of regions; let i = index">
        <div class="ui-g-3 v-align gray-top-border">
          <p-checkbox [inputId]="'chkbox-' + region.id" [value]="region.label" [name]="region.id" [label]="region.label" [(ngModel)]="accountRegistration.selectedRegions"></p-checkbox>
        </div>
        <div class="ui-g-3 v-align gray-top-border">
          <p-inputMask [inputId]="'contract-number-' + region.id" [disabled]="!accountRegistration.isRegionSelected(region.label)" [(ngModel)]="accountRegistration.ruaList[i].contractNumber" [autoClear]="false" mask="****-RUA-aa-2099" [name]="'contract-number-' + region.id" placeholder="XXXX-RUA-XX-20XX"></p-inputMask>
        </div>
        <div class="ui-g-3 v-align gray-top-border">
          <p-calendar [inputId]="'expiration-date-' + region.id"
            [disabled]="!accountRegistration.isRegionSelected(region.label)"
            [(ngModel)]="accountRegistration.ruaList[i].expirationDate"
            [name]="'expiration-date-' + region.id"
            placeholder="YYYY-MM-DD"
            slotChar="YYYY-MM-DD"
            dateFormat="yy-mm-dd"
          ></p-calendar>
        </div>
        <div class="ui-g-3 v-align gray-top-border">
          <div class="v-align form-check1 disabled">
          <label [id]="'btn-upload-rua-for-' + region.id" [class]="accountRegistration.btnChooseRuaFile(region.label)" [for]="'rua-' + region.id">Choose File</label>
          <input [id]="'rua-' + region.id" [name]="'rua-' + region.id" style="display:none" type="file" accept=".pdf" (change)="accountRegistration.processUploadedRuaFile(i, $event.target.files)" [disabled]="!accountRegistration.isRegionSelected(region.label)">
          <label *ngIf="accountRegistration.ruaList[i].ruaUserFileName != ''" [id]="'uploaded-rua-name-' + region.id" class="file-info"><strong>{{accountRegistration.ruaList[i].ruaUserFileName}}</strong></label>
          <label *ngIf="accountRegistration.ruaList[i].ruaUserFileName == ''" [id]="'uploaded-rua-name-' + region.id" class="file-info">No file chosen</label>
        </div></div>
      </div>
      </div-->

      
      <!-- SP ID ------------------------------------------------------------ -->
      <div class="ui-g">
        <div class="ui-g-3">
          <div class="mb-3">
            <label class="form-label" for="spid">SPID</label>
            <div>
              <p-inputMask
                inputId="spid"
                [(ngModel)]="accountRegistration.spid"
                [autoClear]="false"
                mask="****"
                placeholder="xxxx"
                #spid
                #spidMask
                name="spid"
                ngModel
                [style]="{'width': '100%'}"
              ></p-inputMask>
            </div>
          </div>
        </div>
      


      <!-- NPAC User Type --------------------------------------------------- -->
      <!--br-->
      
        <div class="ui-g-3">
          <div class="mb-3">
            <label class="form-label" for="npac-user-type">NPAC User Type</label>
            <div class="input-group">
              <p-dropdown
                #npacUserType
                id="npac-user-type"
                inputId="npac-user-type"
                [placeholder]="'Select'"
                
                [style]="{'width': '100%'}"
                class="p-formcontrol"
                [(ngModel)]="accountRegistration.npacUserType"
                [options]="npacUserTypes"
                name="npacUserType"
              ></p-dropdown>
            </div>
          </div>
        </div>
      

      <!-- Existing iconectiv Services -------------------------------------- -->
      
        <div class="ui-g-3">
          <div class="mb-3">
            <label class="form-label" for="existing-iconectiv-services">Existing iconectiv Services</label>
            <p-multiSelect
                id="existing-iconectiv-services"
                inputId="existing-iconectiv-services"
                placeholder="Select"
                [style]="{'width': '100%'}"
                class="p-formcontrol"
                [(ngModel)]="accountRegistration.otherServicesArray"
                [options]="otherServices"
                name="otherServices">
                <ng-template let-services pTemplate="selectedItems" >
                  <ng-container *ngFor="let val of services">
                      <div class="ui-multiselected-item-token ui-corner-all">{{val}}</div>
                  </ng-container>
                  <span *ngIf="!services || services.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>
                </ng-template>
              
              </p-multiSelect>
          </div>
        </div>
      </div>

     
      <br/>
      <div class="ui-g">
        <p-checkbox [(ngModel)]="acknowledgementBox" name="acknowledgementBox" binary="true" required></p-checkbox>
        <label for="acknowledgementBox">     
          I want to register for a new iconectiv® TruNumber Finder account for my company.
          (If your company already has an account, another registration is not required. 
          Contact your administrator for a login on the existing account.)
        </label>
      </div>

      <div class="ui-g">
        <div class="ui-g-12">
          <div>
            <re-captcha id="recaptcha" (resolved)="resolved($event)" siteKey='{{recaptchaPublicKey}}' ></re-captcha>
          </div>
        </div>
      </div>

      <br/>
      <div class="ui-g">
        <div class="ui-g-9">
          <div style="text-align: left;">
            <button id="btn-submit" type="submit" [class]="'btn ' + btnStyleClass(f.valid)" [disabled]='!isFormValid(f.valid)' >Submit Form</button>
          </div>
        </div>
      </div>

    </div>
  </form>

</div>
